module.exports = __webpack_public_path__ + "img/swiper2.c73595fe.jpg";